import { IconLayer } from "@deck.gl/layers";
import { useSelector } from "react-redux";
import marker from "assets/markers/pin.svg";
import { selectSelectedLocation } from "store/appSlice";

export const MARKER_LAYER_ID = "pointLayer";

export default function MarkerLayer() {
  const location = useSelector(selectSelectedLocation);
  const zoom = useSelector((state) => Math.floor(state.carto.viewState.zoom));
  const visible = useSelector((state) => state.app.simulations.visible);

  if (location == null || !visible) {
    return null;
  }
  const data = [{ coordinates: [location.longitude, location.latitude] }];

  return new IconLayer({
    id: `${MARKER_LAYER_ID}-selected-marker`,
    data: data,
    updateTriggers: {
      getSize: [zoom],
      getPosition: [data],
    },
    getSize: 30,
    sizeUnits: "pixels",
    sizeScale: 1,
    getPosition: (d) => d.coordinates,
    getIcon: () => {
      return {
        url: marker,
        width: 65,
        height: 65,
        anchorY: 65,
      };
    },
    pickable: false,
  });
}
